import { useTranslation } from 'react-i18next';

import { Iframe } from '~/modules/marketing/pages/catalog-anomaly-dashboard/components/iframe/IFrame';

export function KeyMomentsPage() {
  const { t } = useTranslation('marketing');

  return (
    <Iframe
      urlEnvKey="VITE_WMG_EMBED_MARKETING_KEY_MOMENTS_DASHBOARD_URL"
      ariaLabel={t('anomalyDashboard.tabs.keyMoments')}
    />
  );
}

KeyMomentsPage.displayName = 'KeyMomentsPage';
